import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

/**
 * ExamSetupForm - Form component for creating simulated exam sessions
 */
const ExamSetupForm = ({
  examTypes = [],
  selectedExamType,
  setSelectedExamType,
  loading = false,
  error = '',
  isQuotaError = false,
  onStartExam,
  getExamFormat
}) => {
  const format = selectedExamType && getExamFormat ? getExamFormat() : null;

  // Detect quota error from error message if isQuotaError prop is not explicitly set
  const showUpgradeLink = isQuotaError || (error && (
    error.includes('not enabled for the current plan') ||
    error.includes('limit reached') ||
    error.includes('quota') ||
    error.includes('Plan Limit Exceeded') ||
    error.includes('usage page')
  ));

  // Debug logging to track format changes
  // console.log('📝 ExamSetupForm render:', {
  //   selectedExamType,
  //   examTypes: examTypes.length,
  //   format,
  //   formatAvailable: !!format,
  //   error: error // Add error to debug logging
  // });
  // console.log('📝 ExamSetupForm error value:', error);

  return (
    <>
      <h2>Create Simulated Exam Session</h2>
      
      <p>
        Take a full-length simulated exam to test your knowledge and endurance.
        Choose your exam type below to get started.
      </p>

      {error && (
        <div className="validation-message">
          <div>{error}</div>
          {showUpgradeLink && (
            <div style={{ marginTop: '8px' }}>
              <Link 
                to="/usage" 
                style={{ 
                  color: '#007bff', 
                  textDecoration: 'underline',
                  fontWeight: '500'
                }}
              >
                Click Here to Upgrade your plan
              </Link>
            </div>
          )}
        </div>
      )}

      <div className="form-group">
        <label htmlFor="examType" className="form-label">
          Exam Type: <span className="required">*</span>
        </label>
        
        <select
          id="examType"
          value={selectedExamType}
          onChange={(e) => {
            // console.log('ExamSetupForm: Exam type changed to:', e.target.value);
            setSelectedExamType(e.target.value);
          }}
          disabled={loading}
          className={`form-select ${loading ? 'disabled' : ''}`}
          style={{
            backgroundColor: document.body.getAttribute('data-theme') === 'dark' ? '#23272f' : undefined,
            color: document.body.getAttribute('data-theme') === 'dark' ? '#fff' : undefined,
            border: document.body.getAttribute('data-theme') === 'dark' ? '1px solid #444' : undefined
          }}
        >
          <option value="" disabled hidden>Choose an exam type...</option>
          {examTypes.map(type => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </select>
      </div>

      {selectedExamType && format && (
        <div className="exam-format-details">
          <h3 className="exam-format-title">
            Exam Format Details
          </h3>
          
          <div className="exam-format-grid">
            <div className="exam-format-item">
              <strong>Total Questions</strong>
              <div>{format.totalQuestions}</div>
            </div>
            <div className="exam-format-item">
              <strong>Number of Blocks</strong>
              <div>{format.blocks}</div>
            </div>
            <div className="exam-format-item">
              <strong>Questions per Block</strong>
              <div>{format.questionsPerBlock}</div>
            </div>
            <div className="exam-format-item">
              <strong>Time per Block</strong>
              <div>{format.blockTimeMinutes} minutes</div>
            </div>
            <div className="exam-format-item">
              <strong>Total Time</strong>
              <div>{Math.floor(format.totalTime / 60)}h {format.totalTime % 60}m</div>
            </div>
            <div className="exam-format-item">
              <strong>Break Time</strong>
              <div>{format.breakTime} minutes</div>
            </div>
          </div>
        </div>
      )}

      <button
        onClick={onStartExam}
        disabled={!selectedExamType || loading}
        className={`btn btn-primary start-exam-btn ${(!selectedExamType || loading) ? 'disabled' : ''}`}
      >
        {loading ? (
          <>
            <FontAwesomeIcon icon={faSpinner} spin /> Starting Exam...
          </>
        ) : (
          'Start Exam'
        )}
      </button>
    </>
  );
};

export default ExamSetupForm;
